import React from 'react';

export const HeavyFullViewBackdropBlur = () => {
  return <div className="backdrop-blur-3xl fixed inset-0 z-[1]" />;
};
